var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "19px",
    viewBox: "0 0 14 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gumb-App-(MVP)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Event_owner_MVP-2_desktop",
    transform: "translate(-1087.000000, -226.000000)",
    fill: "#10CCC6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1064.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9999839,226.250038 C33.7260569,226.250038 36.7499678,229.270069 36.7499678,233.000021 C36.7499678,235.499714 35.9088634,236.277785 31.431808,243.456303 C30.7721836,244.513906 29.2285052,244.515176 28.5681254,243.456303 C24.093439,236.281527 23.25,235.500229 23.25,233.000021 C23.25,229.273948 26.2700314,226.250038 29.9999839,226.250038 Z M29.9999839,242.562499 C34.5292929,235.300107 35.0624718,234.917886 35.0624718,233.000021 C35.0624718,230.204076 32.7959291,227.937534 29.9999839,227.937534 C27.2040387,227.937534 24.937496,230.204076 24.937496,233.000021 C24.937496,234.926161 25.5202506,235.379586 29.9999839,242.562499 Z M27.1874906,233.000021 C27.1874906,231.44673 28.4466925,230.187528 29.9999839,230.187528 C31.5532753,230.187528 32.8124772,231.44673 32.8124772,233.000021 C32.8124772,234.553313 31.5532753,235.812515 29.9999839,235.812515 C28.4466925,235.812515 27.1874906,234.553313 27.1874906,233.000021 Z",
    id: "\\uF3C5"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGreen);
export default __webpack_public_path__ + "static/media/location-green.5309e21b.svg";
export { ForwardRef as ReactComponent };